import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { styled } from '@mui/system';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

// Color palette based on your website (dark background with coral/peach accent)
const ErrorContainer = styled(Paper)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(4),
  backgroundColor: '#252525', // Dark background matching your site
  borderRadius: theme.shape.borderRadius,
  maxWidth: '400px',
  margin: '20px auto',
  border: '1px solid rgba(255, 255, 255, 0.1)',
}));

const ErrorIcon = styled(ErrorOutlineIcon)(({ theme }) => ({
  fontSize: '3.5rem',
  color: '#ff7a5c', // Coral/peach color from your website's accent
  marginBottom: theme.spacing(2),
}));

const RetryButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#ff7a5c', // Coral/peach color from your website
  color: 'white',
  fontSize: '0.9rem',
  fontWeight: 500,
  padding: '8px 24px',
  borderRadius: '4px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#e86a4d', // Slightly darker on hover
  },
}));

const EmailLink = styled('a')(({ theme }) => ({
  color: '#ff7a5c', // Matching the accent color
  fontWeight: 500,
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

const EnhancedErrorMessage = ({ message }) => {
  return (
    <ErrorContainer elevation={3}>
      <ErrorIcon />
      <Typography variant="h5" align="center" gutterBottom sx={{ color: 'white', fontWeight: 500, mb: 1 }}>
        Error Occurred
      </Typography>
      <Typography variant="body1" align="center" gutterBottom sx={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '1rem', mb: 2 }}>
        {message || "Failed to check payment status: http request failed"}
      </Typography>
      <Box mt={1}>
        <Typography variant="body1" align="center" sx={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.9rem' }}>
          If the problem persists, please email our support team at{' '}
          <EmailLink href="mailto:help@kalakaar.io">support@kalakaar.io</EmailLink>
        </Typography>
      </Box>
      <Box mt={3}>
        <RetryButton variant="contained" onClick={() => window.location.reload()}>
          Retry
        </RetryButton>
      </Box>
    </ErrorContainer>
  );
};

export default EnhancedErrorMessage;